<div class="container">
  <div class="row">
    <div class="col-xl-9 col-lg-9 col-md-9 col-9">
      <h1 mat-dialog-title>{{resource.share_coupon}}</h1>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-3 col-3 text-end">
      <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog-content p-2">
    <h4 class="text-center">{{data.title}}</h4>
    <div class="col-xl-12 col-lg-12 col-md-12 text-center">
      <img mat-card-image [src]="qrCodeImage" width="50%">
    </div>
    <div class="row" *ngIf="qrCodeValue">
      <ul class="social-links">
        <li><a class="facebook" title="facebook" href="https://www.facebook.com/sharer.php?u={{encodeQrCodeValue}}"
            target="_blank"><i class="bx bxl-facebook"></i></a></li>
        <li><a class="twitter" title="twitter" href="https://twitter.com/intent/tweet?text={{encodeQrCodeValue}}"
            target="_blank"><i class="bx bxl-twitter"></i></a></li>
        <li><a class="linkedin" title="linkedin"
            href="https://www.linkedin.com/sharing/share-offsite/?url={{encodeQrCodeValue}}" target="_blank"><i
              class="bx bxl-linkedin"></i></a></li>
        <!-- <li><a class="instagram" title="instagram"
            href="https://www.linkedin.com/shareArticle?mini=true&url={{encodeQrCodeValue}}" target="_blank"><i
              class="bx bxl-instagram"></i></a></li> -->
        <li><a class="whatsapp" title="whatsapp" href="https://web.whatsapp.com/send?text={{encodeQrCodeValue}}"
            target="_blank"><i class="bx bxl-whatsapp"></i></a></li>
        <li (click)="onClickCopyURL()"><span class="copy" title="copy"><i class="bx bx-copy-alt"></i></span></li>
        <li (click)="onClickDownloadQrCode()"><span class="download" title="download"><i
              class="bx bx-download"></i></span></li>
      </ul>
    </div>
  </div>
</div>